module.exports = __webpack_public_path__ + "static/media/tint.0708986a.svg";